import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { nortadaLogger } from '../../../../../../common/logger';
import {
  NameAndMsisdnType,
  NameAndBankAccountType,
  MsisdnAndDateOfBirthType,
  BvnAndNameAndDateOfBirthType
} from '../../../../../../../api/interfaces';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';
import { convertQueryTypeToRedableFormat } from '../../../../../../common/table/utils/operationTypeFormatters';

import { OperationSuccess } from './interfaces';
import { validationResultValueFormatter } from './dictionary';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details } = operation;

  const detailsDependingOnTheQueryType = () => {
    const detailsQueryType = details.query.type;
    const convertedDetailsQueryType = convertQueryTypeToRedableFormat(detailsQueryType);

    switch (details.query.type) {
      case 'NAME_AND_MSISDN': {
        const detailsQuery = details.query as NameAndMsisdnType;

        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.type,
                value: convertedDetailsQueryType
              },
              { label: locales.operation.label.name, value: detailsQuery.name },
              {
                label: locales.operation.label.msisdn,
                value: detailsValueFormatter(detailsQuery.msisdn)
              },
              {
                label: locales.operation.label.customerValidationResult,
                value: detailsValueFormatter(details.validationResult, validationResultValueFormatter)
              }
            ]}
          />
        );
      }
      case 'NAME_AND_BANK_ACCOUNT': {
        const detailsQuery = details.query as NameAndBankAccountType;

        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.type,
                value: convertedDetailsQueryType
              },
              { label: locales.operation.label.name, value: detailsQuery.name },
              { label: locales.operation.label.bankCode, value: detailsQuery.bankCode },
              {
                label: locales.operation.label.bankAccountNumber,
                value: detailsQuery.bankAccountNumber
              },
              {
                label: locales.operation.label.customerValidationResult,
                value: detailsValueFormatter(details.validationResult, validationResultValueFormatter)
              }
            ]}
          />
        );
      }
      case 'MSISDN_AND_DATE_OF_BIRTH': {
        const detailsQuery = details.query as MsisdnAndDateOfBirthType;

        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.type,
                value: convertedDetailsQueryType
              },
              {
                label: locales.operation.label.msisdn,
                value: detailsValueFormatter(detailsQuery.msisdn)
              },
              {
                label: locales.operation.label.dateOfBirth,
                value: detailsQuery.dateOfBirth
              },
              {
                label: locales.operation.label.customerValidationResult,
                value: detailsValueFormatter(details.validationResult, validationResultValueFormatter)
              }
            ]}
          />
        );
      }
      case 'BVN_AND_NAME_AND_DATE_OF_BIRTH': {
        const detailsQuery = details.query as BvnAndNameAndDateOfBirthType;

        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.type,
                value: convertedDetailsQueryType
              },
              { label: locales.operation.label.name, value: detailsQuery.name },
              { label: locales.operation.label.bvn, value: detailsQuery.bvn },
              {
                label: locales.operation.label.dateOfBirth,
                value: detailsQuery.dateOfBirth
              },
              {
                label: locales.operation.label.customerValidationResult,
                value: detailsValueFormatter(details.validationResult, validationResultValueFormatter)
              }
            ]}
          />
        );
      }
      default: {
        nortadaLogger.critical(`${detailsQueryType} type is not defined type`);
        return null;
      }
    }
  };
  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={detailsDependingOnTheQueryType()}
    />
  );
};

export default SuccessOperation;
